import React from 'react';
import equal from 'fast-deep-equal/react';
import { useTranslation } from 'react-i18next';
import {
    DivTooltip, Tooltip, Divider, TooltipBody, TooltipHeader
} from '@wg/wows-react-uikit';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import { PresentationStyles } from '@wg/wows-entities/const';

import type { RootState as State } from '~/store';
import { useAppSelector } from '~/hooks';
import Text from '~/Components/Text/Text';
import QuantityText from '~/Components/QuantityText/QuantityText';


import styles from '~/Components/ProgressBar/PostProgression/PostProgression.scss';

import ImagePostProgression from '~/assets/images/icons/compensation-steel-new.png';


export interface IPostProgressionState {
    compensations: Array<CompensationItem>,
}

const stateSelector = (state: State): IPostProgressionState => {
    return {
        compensations: state.app.compensations,
    };
};

const PostProgression = () => {
    const { compensations } = useAppSelector(stateSelector, equal);
    const { t } = useTranslation();

    const renderIcon = React.useCallback((type: CompensationItem['type']) => {
        return (
            <WoWSEntity
                type={type}
                presentation={{
                    withTooltip: false,
                    withText: true,
                    style: PresentationStyles.WIDGET,
                }}
            />
        );
    }, []);

    const tooltip = React.useMemo(() => {
        return (
            <Tooltip className={styles.tooltip}>
                <TooltipHeader className={styles.tooltipHeader}>
                    {t('Компенсация за этапы строительства')}
                </TooltipHeader>
                {compensations.map((compensationItem: CompensationItem, i: number) => {
                    return (
                        <React.Fragment key={`compensation-item-${i}`}>
                            <TooltipBody>
                                {renderIcon(compensationItem.type)}
                            </TooltipBody>
                            <QuantityText
                                type={compensationItem.type}
                                amount={compensationItem.amount}
                            />
                        </React.Fragment>
                    );
                })}
                <Divider type={'major'} />
                <TooltipBody>
                    <Text
                        str={t('Каждый дополнительный этап после постройки %(ship)s')}
                        clickableVehicles={false}
                    />
                </TooltipBody>
            </Tooltip>
        );
    }, [compensations, renderIcon, t]);

    return (
        <DivTooltip className={styles.wrapper} tooltipBody={tooltip} fixed position={'top'}>
            <div className={styles.inner}>
                <img className={styles.image} src={ImagePostProgression} width={80} height={80} />
                <div className={styles.title}>
                    {t('Компенсация за этапы')}
                </div>
            </div>
        </DivTooltip>
    );
};

export default React.memo(PostProgression);
